import {memo, useEffect} from 'react'
// import {DatatableComponent} from '../../../shared/DatatableComponent/DataTableComponent'
import {useAppDispatch, useAppSelector} from '../../../../hooks'
import {DataTableComponent} from '@omniyat/reactcomponents'
import {Image} from 'primereact/image'

import {Chip} from 'primereact/chip'
import {
  fetchStaffTag,
  fetchTeams,
  getTeams,
  removeTeam,
  setEditTeam,
  setSelectedTeam,
  setSelectedTeamV,
  setSelectedUser,
  setShow,
} from '../../slice/team.slice'
import {OlangItem} from '../../../shared/Olang/user-interface/OlangItem/OlangItem'
import {SplitButton} from 'primereact/splitbutton'
import {useState} from 'react'
import {setAlertParams} from '../../../../store/slices/alert.slice'
import UserEdit from './UserEdit'
import {Panel} from 'primereact/panel'
import {API_BASE_URL_IMAGE} from '../../../../api/config'
import {fetchValidator} from '../../../Inventory/slice/inventory.slice'
import { PageHeader } from '../../../shared/PageHeader/PageHeader'
import { setToastParams } from '../../../../store/slices/ui.slice'

const TeamList = () => {
  const [dialogVisible, setDialogVisible] = useState(false)
  const [isLoadingButton, setIsLoadingButton] = useState(false)
  const [showTag, setShowTag] = useState([])

  const teams = useAppSelector(getTeams)

  const dispatch = useAppDispatch()

  let actions = [
        {
      label: 'Detail',
      icon: 'pi pi-eye text-blue-500',
      command: (e) => {
        // toast.current.show({severity: 'success', summary: "success", detail: "Supprimer avec success!!!"})
        // console.log('eee:', e)
        dispatch(fetchStaffTag({id: e.item.data.id})).then(() => {
          dispatch(fetchValidator('staff'))
          dispatch(setSelectedTeamV(e.item.data))
          dispatch(setShow(false))
        })
      },
    },
    {
      label: 'Supprimer',
      icon: 'pi pi-trash text-red-500',
      command: (e) => {
        dispatch(setSelectedTeamV(e.item.data))
        console.log('delete team command:', e.item.data)
        dispatch(
          setAlertParams({
            title: `Supression utilisateur (${e.item.data?.login || ''})`,
            message:'Voulez-vous vraiment supprimercet équipe?',
            acceptClassName: 'p-button-danger',
            visible: true,
            accept: () => {
              console.log('delete team:', e.item.data)
              // if(e.item.data?.login == 'admin') return
              dispatch(removeTeam(e.item.data)).then(({payload})=>{
                let res = payload?.[0]
                if(res?.success == 'failed'){
                  dispatch(
                    setToastParams({
                      show: true,
                      severity: 'error',
                      summary: 'ERREUR',
                      detail: res?.message,
                      position: 'top-right',
                    })
                  )
                }
                console.log('payload delete team:', payload)
              })
            },
          })
        )
      },
    },

    {
      label: `Utilisateur`,
      icon: 'pi pi-user text-blue-500',
      command: (e) => {
        dispatch(setSelectedTeamV(e.item.data))
        setDialogVisible(true)
      },
    },
  ]
  const activeTemplate = (rowData) => (
    <Chip
      label={rowData?.active == 1 ? 'Actif' : 'Inactif'}
      icon={rowData?.active == 1 ? 'pi pi-check' : 'pi pi-times'}
      className={'text-white ' + (rowData?.active == 1 ? 'bg-green-500' : 'bg-red-500')}
    />
  )

  const imageTemplate = (rowData) => {
    const imageSrc = rowData?.image ? `${API_BASE_URL_IMAGE}${rowData.image}` : null
    
    if (!imageSrc) {
      return (
        <div 
          className='flex align-items-center justify-content-center rounded bg-gray-200'
          style={{width: '60px', height: '60px'}}
        >
          <i className="fas fa-user text-gray-500" style={{fontSize: '24px'}}></i>
        </div>
      )
    }
    
    return (
      <img
        src={imageSrc}
        alt='StaffImage'
        className='image-preview rounded'
        style={{width: '60px', height: '60px', objectFit: 'cover'}}
        onError={(e) => {
          e.target.style.display = 'none'
          e.target.parentElement.innerHTML = `
            <div class="flex align-items-center justify-content-center rounded bg-gray-200" style="width: 60px; height: 60px;">
              <i class="fas fa-user text-gray-500" style="font-size: 24px;"></i>
            </div>
          `
        }}
      />
    )
  }
  const actionTemplate = (rowData) => {
    actions = actions.map((_i) => ({..._i, data: rowData}))
    return (
      <div>
        <SplitButton
          model={actions}
          className='p-button-help p-button-raised  p-button-outlined p-button-sm bg-white'
        />
      </div>
    )
  }

  const showTagById = (rowData) => {
    console.log('showTagById', rowData)
    console.log('showTag', showTag)
    if (showTag?.includes(rowData?.id)) {
      let update = showTag?.filter((x) => x != rowData?.id)
      setShowTag(update)
      return
    }
    setShowTag([...showTag, rowData?.id])
  }

  const familleTagTemplate = (rowData) => {
    return (
      <Chip
        label={rowData.tagFamille}
        title={rowData.tagId != 0 ? `Tagged  ${rowData?.tagDate}` : 'No Tag'}
        alt={rowData.tagId != 0 ? `Tagged  ${rowData?.tagDate}` : 'No Tag'}
        icon={rowData.tagFamilleIcon}
        style={{background: rowData.tagFamilleBgColor, color: 'white'}}
        className='cursor-pointer'
        onClick={() => showTagById(rowData)}
      />
    )
  }

  const tagTemplate = (rowData) => {
    return (
      <div className='flex flex-column'>
        <div className='flex justify-content-center'>
          {rowData.tagId ? (
            familleTagTemplate(rowData)
          ) : (
            <Chip label='Untagged' className='cursor-pointer' />
          )}
        </div>
        {showTag.includes(rowData?.id) ? (
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Chip
              label={
                rowData?.tagName === null ||
                rowData?.tagName === '' ||
                rowData?.tagName == undefined
                  ? rowData?.tagName
                  : rowData?.tagName
              }
              className='m-2'
              style={{background: rowData?.familleTagIconBgcolor || '#D64B70', color: 'white'}}
            />
          </div>
        ) : null}
      </div>
    )
  }

  // const emptyColumn = (rowData) =>
  // rowData?.exitday == null ? <p className='pi pi-minus ml-4'></p> : rowData?.exitday
  const columns = [
    {
      header: 'Photo',
      field: 'image',
      olang: 'Photo',
      body: imageTemplate,
    },
    {
      header: 'Nom employé',
      field: 'lastname',
      olang: 'Nom.employe',
      filter: true,
    },
    {
      header: 'Prénom',
      field: 'firstname',
      olang: 'Prenom',
      filter: true,
    },
    {
      header: 'Tag',
      field: 'tagName',
      olang: 'Tag',
      body: tagTemplate,
    },
    {
      header: 'Login',
      field: 'login',
      olang: 'Login',
      filter: true,
    },
    {
      header: 'Function',
      field: 'famille',
      olang: 'Function',
      filter: true,
    },
    {
      header: 'hireday',
      olang: 'hireday',
      field: 'hireday',
      filter: true,
    },
    {
      header: 'exitday',
      olang: 'exitday',
      field: 'exitday',
      filter: true,
    },
    {
      header: 'Status',
      olang: 'status',
      field: 'active',
      body: activeTemplate,
    },
  ]

  const exportFields = [
    {label: 'Nom employé', column: 'lastname'},
    {label: 'Prénom', column: 'firstname'},
    {label: 'Function', column: 'famille'},
    {label: 'hireday', column: 'hireday'},
    {label: 'exitday', column: 'exitday'},
  ]

  const allowedGroupFields = ['famille']

  const rowGroupTemplates = {
    famille: (rowData) => (
      <Chip style={{backgroundColor: '#D64B70', color: 'white'}} label={rowData?.famille} />
    ),
  }

  let create = () => {
    setIsLoadingButton(true)
    dispatch(fetchValidator('staff'))
      .then(() => {
        dispatch(setEditTeam(true))
        dispatch(setSelectedTeamV(null))
      })
      .finally(() => setIsLoadingButton(false))
  }

  useEffect(() => {
    dispatch(fetchTeams())
  }, [])

  return (
    <>
      {/* Page Header */}
      <PageHeader
        titleOlang="staff.list"
        backPath="/dashboard"
        info={
          <div className="flex align-items-center gap-2">
            <i className="pi pi-users text-xl text-primary"></i>
            <span className="text-lg font-semibold">
              {teams?.length || 0} équipe{(teams?.length || 0) > 1 ? 's' : ''}
            </span>
          </div>
        }
        className="m-3"
      />
      <DataTableComponent
        tableId='team-table'
        data={teams}
        columns={columns}
        exportFields={exportFields}
        onNew={create}
        rowGroupTemplates={rowGroupTemplates}
        allowedGroupFields={allowedGroupFields}
        contextMenuModel={actions}
        onSelections={(r) => console.log('data:', r)}
        rowActions={actions}
        isLoading={isLoadingButton}
      />
      <UserEdit
        dialogVisible={dialogVisible}
        setDialogVisible={() => setDialogVisible((prev) => !prev)}
      />
    </>
  )
}

export default TeamList
